import { css } from "@emotion/css";
import { space, text, themeTokens, borderWidth, fontSize } from "@octopusdeploy/design-system-tokens";
export interface SectionHeaderProps {
    title: string | JSX.Element;
    description?: string | JSX.Element;
}
export function SectionHeader({ title, description }: SectionHeaderProps) {
    return (<div className={sectionHeaderStyles}>
            <div className={sectionHeaderTitleStyles}>{title}</div>
            {description && <div className={sectionHeaderDescriptionStyles}>{description}</div>}
        </div>);
}
const sectionHeaderStyles = css({
    width: "100%",
    marginBottom: "-0.0725rem",
    paddingBottom: space[1],
    backgroundColor: themeTokens.color.background.secondary.default,
    borderWidth: borderWidth.none,
    borderTop: `${borderWidth[1]} solid ${themeTokens.color.border.primary}`,
    borderRadius: 0,
});
const sectionHeaderTitleStyles = css({
    color: themeTokens.color.text.primary,
    font: text.body.regular.large,
    paddingTop: "0.6rem",
    paddingBottom: "0.6rem",
    paddingLeft: space[16],
    paddingRight: space[16],
    "&:not(:last-child)": {
        paddingBottom: space[2],
    },
});
const sectionHeaderDescriptionStyles = css({
    padding: "0 1rem 0.6rem 1rem",
    fontSize: fontSize.small,
    color: themeTokens.color.text.tertiary,
});
